export default "__VITE_ASSET__BCdwB5zF__"